// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__zfvYM","title":"InfoRow_title__2YYzd"};